import { OrganizationTeamWithMembersResponseDto } from 'app/API';
import { Wrapper } from './styles/Wrapper';
import { TeamCard } from './TeamCard';

type TProps = {
  teams: OrganizationTeamWithMembersResponseDto[];
};

export function TeamCards({ teams }: TProps) {
  return (
    <Wrapper>
      <ul className="list">
        {teams.map((team) => (
          <TeamCard key={team.id} team={team} />
        ))}
      </ul>
    </Wrapper>
  );
}
